// 📁 src/redux/slices/dateOptionsSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

// ✅ Types
interface DateOption {
  label: string;
  value: string;
}

interface FetchDateParams {
  page?: number;
  limit?: number;
  searchTerm?: string | null | any;
  DATE?: any; // changed to any
  TITLE?: any;
  FILE_NAME?: any;
}

interface DateOptionsState {
  DateOption: any;
  loadingOfDate: boolean;
  error: string | null;
  hasMore: boolean;
  currentPage: number;
  limit: number;
}

// ✅ Initial State
const initialState: DateOptionsState = {
  DateOption: [],
  loadingOfDate: false,
  error: null,
  hasMore: true,
  currentPage: 1,
  limit: 10,
};

// ✅ Async Thunk
export const FetchDate = createAsyncThunk(
  "dateOptions/fetch",
  async (params: FetchDateParams = {}, { rejectWithValue }) => {
    try {
      const queryParams: string[] = [];

      if (params.page !== undefined) queryParams.push(`page=${params.page}`);
      if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
      if (params.searchTerm !== undefined)queryParams.push(`searchTerm=${params.searchTerm}`);
      // if (params.DATE?.length) queryParams.push(`DATE=${params.DATE}`);
       if (Array.isArray(params.DATE)) {
        params.DATE.forEach(date => {
          queryParams.push(`DATE=${encodeURIComponent(date)}`);
        });
      }
        if (Array.isArray(params.TITLE)) {
        params.TITLE.forEach(title => {
          queryParams.push(`TITLE=${encodeURIComponent(title)}`);
        });
      }
        if (Array.isArray(params.FILE_NAME)) {
        params.FILE_NAME.forEach(file => {
          queryParams.push(`FILE_NAME=${encodeURIComponent(file)}`);
        });
      }
      // if (params.TITLE?.length) queryParams.push(`TITLE=${params.TITLE}`);
      // if (params.FILE_NAME?.length)
      //   queryParams.push(`FILE_NAME=${params.FILE_NAME}`);

      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await axios.get(
        `${API.GETDATEOPTIONSINKDD}${queryString}`
      );

      return {
        data: response.data,
        page: params.page ?? 1,
      };
    } catch (err: any) {
      if (err.response?.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

// ✅ Slice
const dateOptionsSlice = createSlice({
  name: "dateOptions",
  initialState,
  reducers: {
    clearDateOptions: (state) => {
      state.DateOption = [];
      state.currentPage = 1;
      state.hasMore = true;
      state.loadingOfDate = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchDate.pending, (state) => {
        state.loadingOfDate = true;
        state.error = null;
      })
      .addCase(FetchDate.fulfilled, (state, action) => {
        const { data, page } = action.payload;

        const formatted = (data.date_options || []).map((item: string) => ({
          label: item,
          value: item,
        }));

        if (page === 1) {
          state.DateOption = formatted;
        } else {
          state.DateOption = [...state.DateOption, ...formatted];
        }

        state.currentPage = page;
        state.hasMore = data.hasMore;
        state.loadingOfDate = false;
      })
      .addCase(FetchDate.rejected, (state, action) => {
        state.loadingOfDate = false;
        state.error = (action.payload as string) ?? "Fetch failed";
      });
  },
});

// ✅ Export Actions and Reducer
export const { clearDateOptions } = dateOptionsSlice.actions;
export default dateOptionsSlice.reducer;
